import React from "react";
import _ from "lodash";
import { Routes, Route } from "react-router-dom";
import { lazyRetry } from "src/utils/lazyRetry";

/* ── СТАТИК: нэвтэрсэн БҮХ хэрэглэгчийн зам ────────────────────────────
   ⚠ `MainRoute` нь үл мэдэгдэх замын НӨӨЦ (router.js) тул модуль өөрөө
     статик хэвээр байх ёстой — доорх хуудсуудын зарим нь л lazy.      */
import Dashboard from "src/pages/dashboard";
import Me from "src/pages/me/index";
// Миний даалгавар — хяналт шалгалтаар надад хувиарлагдсан зөрчил.
// ⚠ ЦЭСНИЙ ЭРХЭЭС ҮЛ ХАМААРНА: даалгавар авдаг хүн нь ихэвчлэн
//   энгийн ажилтан, шалгалтын цэс байдаггүй. Тиймээс `main`-д
//   байрлуулав — нэвтэрсэн бүх хэрэглэгч хандана.
import MyAssignments from "src/pages/MyAssignments";

/* ── LAZY: МЭРГЭЖИЛТНИЙ хуудас → "hse" chunk (2026-10-29) ─────────────
   ⚠ ЯАГААД ЭНЭ ХОЁР: `dataAnalysis` нь `@ant-design/plots` (G2Plot)-ыг
     импортолдог. Source map-ийн хэмжилтээр тэр график сан `main.js`-д
     @antv/g2 794 KB + g2plot 556 KB + component 221 KB + g-base 115 KB
     = 1 686 KB эх код эзэлж байв — `main.js`-ийн 20%.
     Статик байсан тул ажилтан `/me` нээхэд ч бүгд татагддаг байсан.
   ⚠ `/me`, `/dashboard`, `/my-assignments` нь СТАТИК хэвээр — ажилтны
     өдөр тутмын зам chunk-гүй байх зарчим хэвээр.                     */
const DataAnalysis = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/dataAnalysis"),
);
// ЕРӨНХИЙ ЛАВЛАХ — апп даяар хэрэглэгдэх лавлахуудын төв (модуль тус бүрийн
// лавлахаас ТУСДАА: нэг модульд биш, бүгдэд хамаарна)
const SettingsReference = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/settings/reference"),
);

const Main = () => {
  const data = [
    { path: "/me", component: <Me /> },
    { path: "/dashboard", component: <Dashboard /> },
    { path: "/data-analysis", component: <DataAnalysis /> },
    { path: "/my-assignments", component: <MyAssignments /> },
    { path: "/settings/reference", component: <SettingsReference /> },
  ];
  return (
    <Routes>
      {_.map(data, (el) => {
        return (
          <Route key={el.path} exact path={el.path} element={el.component} />
        );
      })}
    </Routes>
  );
};

export default React.memo(Main);
